module.exports = __webpack_public_path__ + "static/media/WhitneySSm-Book-Adv_Web.dde67203.woff2";